define.alias("shared/modifiers/wheel-pan", "preview-grid/modifiers/wheel-pan");